import { useEffect } from 'react';
import type { JSX } from 'react';
import { useAuthStore } from './stores/authStore';
import { useKeyboardShortcuts } from './hooks/useKeyboardShortcuts';
import AppLayout from './components/AppLayout';
import LoginPage from './pages/LoginPage';

export default function App(): JSX.Element {
  const { authenticated, loading, checkSession } = useAuthStore();
  useKeyboardShortcuts();

  useEffect(() => {
    checkSession();

    // Listen for auth expiration from API client
    const handleExpired = () => checkSession();
    window.addEventListener('auth:expired', handleExpired);
    return () => window.removeEventListener('auth:expired', handleExpired);
  }, [checkSession]);

  useEffect(() => {
    if (/Electron/i.test(navigator.userAgent)) {
      document.documentElement.setAttribute('data-platform', 'electron');
    }
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        color: 'var(--text-secondary)',
        fontFamily: 'var(--font-ui)',
      }}>
        Loading...
      </div>
    );
  }

  return authenticated ? <AppLayout /> : <LoginPage />;
}
